import { z } from "zod";

export const hasUppercaseEmailCharacters = (value: string) =>
  value.trim() !== value.trim().toLowerCase();

/** Email schema that trims input and requires lowercase characters only. */
export const lowercaseEmailSchema = (
  invalidEmailMessage: string,
  lowercaseEmailMessage: string,
) =>
  z
    .string()
    .trim()
    .email(invalidEmailMessage)
    .refine((value) => !hasUppercaseEmailCharacters(value), {
      message: lowercaseEmailMessage,
    });
